import React, { useMemo } from 'react';

interface Star {
  x: number;
  y: number;
  r: number;
  o: number;
  d: number;
}

interface StarFieldProps {
  count?: number;
  seedOffset?: number;
}

export function StarField({ count = 120, seedOffset = 0 }: StarFieldProps) {
  const stars = useMemo(() => {
    const seed = (n: number): number => {
      const x = Math.sin((n + seedOffset) * 9999.7);
      return x - Math.floor(x);
    };

    return Array.from({ length: count }, (_, i): Star => ({
      x: seed(i) * 100,
      y: seed(i + 0.3) * 100,
      r: 0.15 + seed(i + 0.8) * 0.95,
      o: 0.2 + seed(i + 0.4) * 0.75,
      d: 2 + seed(i + 0.6) * 3,
    }));
  }, [count, seedOffset]);

  return (
    <svg
      style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
    >
      {stars.map((s, i) => (
        <circle key={i} cx={s.x} cy={s.y} r={s.r * 0.25} fill="#FFF4D4" opacity={s.o}>
          <animate
            attributeName="opacity"
            values={`${s.o};${s.o * 0.25};${s.o}`}
            dur={`${s.d}s`}
            repeatCount="indefinite"
          />
        </circle>
      ))}
    </svg>
  );
}
